function FetchError(errorDetails) {
    const instance = new Error('fetch error');
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));

    instance.errorDetails = errorDetails;

    return instance;
}
FetchError.prototype = Object.create(Error.prototype, {
    constructor: {
        value: Error,
        enumerable: false,
        writable: true,
        configurable: true,
    },
});

Object.setPrototypeOf(FetchError, Error);

export default FetchError;
